function addToHeaderMenu() {
	if (typeof switcherClass !== "undefined" && typeof sidebarClass !== "undefined" && typeof headerClass !== "undefined") {
		const switcher = document.querySelector(`.${switcherClass}`);
		if (switcher) {
			clicked = false;
			switcher.addEventListener("click", function () {
				if (clicked === false) {
					const menuItems = document.querySelectorAll(`.${sidebarClass} .${sidebarClass}__content > *`);
					if (menuItems.length > 0) {
						const header = document.querySelector(`.${headerClass} .menu`);
						menuItems.forEach((menu) => {
							const clonedMenu = menu.cloneNode(true);
							clonedMenu.classList.add("mobile");
							header.appendChild(clonedMenu);
						});
					}
					clicked = true;
				}
			});
		}
	}
}

document.addEventListener("DOMContentLoaded", () => addToHeaderMenu());
